import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class FideGatewayService {
  private apiServerUrl = environment.loganConfig.url;

  constructor(private http: HttpClient) {}

  public getFindGateway(serial: string[]): Observable<string> {
    return this.http.post<string>(
      `${this.apiServerUrl}/api/others/findGateway`,
      { seriais: serial },
      { withCredentials: true }
    );
  }
}
